// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"GdprSettings-module--checkbox--3GX92"};